// Extension of the admin API helper for university-logo management.

import { getToken, clearToken } from './adminApi';

const BASE = process.env.REACT_APP_BACKEND_URL;

function _authHeaders(extra = {}) {
  const t = getToken();
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

async function _handle(res) {
  if (res.status === 401) { clearToken(); throw Object.assign(new Error('Unauthorized'), { status: 401 }); }
  if (!res.ok) {
    let detail = 'Request failed';
    try {
      const b = await res.json();
      if (b?.detail) detail = typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail);
    } catch (_) { /* ignore */ }
    throw Object.assign(new Error(detail), { status: res.status });
  }
  return res.json();
}

export async function listUniversityLogos() {
  const res = await fetch(`${BASE}/api/admin/university-logos`, { headers: _authHeaders() });
  return _handle(res);
}

export async function uploadUniversityLogo(slug, file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE}/api/admin/universities/${encodeURIComponent(slug)}/logo`, {
    method: 'POST',
    headers: _authHeaders(),
    body: fd,
  });
  return _handle(res);
}

export async function deleteUniversityLogo(slug) {
  const res = await fetch(`${BASE}/api/admin/universities/${encodeURIComponent(slug)}/logo`, {
    method: 'DELETE',
    headers: _authHeaders(),
  });
  return _handle(res);
}

export async function publicUniversityLogos() {
  const res = await fetch(`${BASE}/api/universities/logos`);
  if (!res.ok) return {};
  return res.json();
}
